module.exports = __webpack_public_path__ + "static/media/_canary-islands.e0e16b07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_canary-islands.svg
// module id = 2308
// module chunks = 7